export const SET_METADATA = 'src/store/metadata/SET_METADATA';
